// extracted by mini-css-extract-plugin
export var indicator = "style-module--indicator--c67de";